import { z } from 'zod'
import { StoreCatalogLayout, type StoreThemeSetting } from '../../models/AppSetting'

export const StoreThemeSettingDTOSchema = z.object({
  primary_color: z.string().nullable().optional(),
  secondary_color: z.string().nullable().optional(),
  favicon_url: z.string().nullable().optional(),
  cover_image_url: z.string().nullable().optional(),
  catalog_layout: z.enum([StoreCatalogLayout.List, StoreCatalogLayout.Feed]).nullable().optional()
})

export type StoreThemeSettingDTO = z.infer<typeof StoreThemeSettingDTOSchema>

function normalizeHexColor (color: string | undefined): string | undefined {
  if (!color) { return undefined }
  const cleaned = color.replace('#', '')
  return cleaned ? `#${cleaned}` : undefined
}

export function mapDTOToStoreThemeSetting (dto: StoreThemeSettingDTO): StoreThemeSetting {
  return {
    primaryColor: normalizeHexColor(dto.primary_color ?? undefined),
    secondaryColor: normalizeHexColor(dto.secondary_color ?? undefined),
    faviconUrl: dto.favicon_url ?? undefined,
    coverImageUrl: dto.cover_image_url ?? undefined,
    catalogLayout: dto.catalog_layout ?? StoreCatalogLayout.List
  }
}

export function mapStoreThemeSettingToDTO (model: StoreThemeSetting): StoreThemeSettingDTO {
  return {
    primary_color: normalizeHexColor(model.primaryColor),
    secondary_color: normalizeHexColor(model.secondaryColor),
    favicon_url: model.faviconUrl ?? null,
    cover_image_url: model.coverImageUrl ?? null,
    catalog_layout: model.catalogLayout ?? StoreCatalogLayout.List
  }
}
